<template>
    <div>
        <div class="bg-white rounded shadow-md group" :class="{'h-full': wantsFullHeight}">
            <div class="w-full px-6 py-4 font-bold bg-gray-300 rounded-t text-gray-800 relative">
                <slot name="header"></slot>
            </div>
            <slot name="body"></slot>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            'wantsFullHeight': {
                default: false,
            } 
        },
    }
</script>